import e from "./_baseAssignValue.js";
import t from "./_createAggregator.js";
var g = e, p = t, s = Object.prototype, c = s.hasOwnProperty, i = p(function(r, o, a) {
  c.call(r, a) ? r[a].push(o) : g(r, a, [o]);
}), b = i;
export {
  b as default
};
//# sourceMappingURL=groupBy.js.map
